import React, { useState } from "react";
import "./Calendar.scss";
import { Link, NavLink, useNavigate } from "react-router-dom";
import {
  monthSerb,
  calendarYears,
  redDaysId,
  inCalendarArr,
  easterDays,
} from "./calendar-data/calendar-data";
import SimpleButton from "../../UI/Buttons/SimpleButton";
import TimeFormat from "../TimeFormat/TimeFormat";
import { useGlobalLocation } from "../../shared/LocationContext";
import { useIdContext } from "../../shared/IdProvider";
import AdManagerSlot from "../AdvModule/AdManagerSlot";
import StickyAd from "../AdvModule/StickyAd";
import { renderTitleSection } from "../../shared/utility";

export default function Calendar(props) {
  const { id, currentDate, isYear, isMonth, holidays, isEasterDay } =
    useIdContext();
  const location = useGlobalLocation();
  const [dropDownYear, setDropDownYear] = useState(false);
  const navigate = useNavigate();

  const changeMonth2 = (val) => {
    if (id === undefined) {
      // navigate(`/crkveni-kalendar/${isYear}/${tableTitle(val)}/`);
      if (val === 1) {
        navigate(`../crkveni-kalendar/${isYear + 1}/januar/`);
      } else {
        navigate(`../crkveni-kalendar/${isYear}/${monthSerb[isMonth - 1]}/`);
      }
    } else if (isMonth === 11 && val === 1) {
      navigate(`../crkveni-kalendar/${+isYear + 1}/januar/`);
    } else if (isMonth === 0 && val === -1) {
      navigate(`../crkveni-kalendar/${+isYear - 1}/decembar/`);
    } else {
      navigate(`../crkveni-kalendar/${isYear}/${tableTitle(val)}/`);
    }
  };

  const changeMonth = (val) => {
    if (id === undefined) {
      if (isMonth === 11 && val === 1) {
        navigate(`../crkveni-kalendar/${isYear + 1}/januar/`);
      } else if (isMonth === 0 && val === -1) {
        navigate(`../crkveni-kalendar/${isYear - 1}/decembar/`);
      } else {
        navigate(`../crkveni-kalendar/${isYear}/${monthSerb[isMonth + val]}/`);
      }
    } else if (isMonth === 11 && val === 1) {
      navigate(`../crkveni-kalendar/${+isYear + 1}/januar/`);
    } else if (isMonth === 0 && val === -1) {
      navigate(`../crkveni-kalendar/${+isYear - 1}/decembar/`);
    } else {
      navigate(`../crkveni-kalendar/${isYear}/${tableTitle(val)}/`);
    }
  };

  function setMonth(short) {
    if (short) {
      //short month on home page
      const setShortCal = () => {
        if (currentDate.getDate() < 7) {
          return holidays.slice(0, currentDate.getDate() + short);
        } else {
          return holidays.slice(
            currentDate.getDate() - short,
            currentDate.getDate() + short
          );
        }
      };
      return setShortCal();
    } else {
      return holidays;
    }
  }
  const tableTitle = (x) => {
    if (id === undefined) {
      if (isMonth + x === 12) {
        return `JANUAR (${+isYear + 1})`;
      } else if (isMonth + x === -1) {
        return `${monthSerb[11]} (${+isYear + x})`;
      } else {
        return monthSerb[isMonth + x];
      }
    } else {
      if (isMonth + x === 12) {
        return `${monthSerb[0]} (${+isYear + x})`;
      } else if (isMonth + x === -1) {
        return `${monthSerb[11]} (${+isYear + x})`;
      } else {
        return monthSerb[monthSerb.indexOf(id) + x];
      }
    }
  };
  const rowClasses = (item, zz) => {
    return redDaysId.includes(item.id) ||
      (easterDays.includes(item.title) && zz !== 4 && zz !== 6)
      ? "normalRow"
      : "";
  };

  const todayClass = (x) => {
    return x.toDateString() === currentDate.toDateString() ? " today" : "";
  };

  const setCloseClass = () => {
    if (location.pathname === "/") {
      return " close";
    } else {
      return "";
    }
  };

  //change the calendar year
  const items_list = (items) => {
    return (
      <ul className={getDropDownMenu()}>
        {items.map((item, index) => {
          return (
            <NavLink
              to={`/crkveni-kalendar/${item.title}/${monthSerb[isMonth]}/`}
              key={index}
              onClick={() => setDropDownYear(false)}
            >
              {item.title}
            </NavLink>
          );
        })}
      </ul>
    );
    // }
  };
  const getDropDownMenu = () => {
    return dropDownYear ? "drop_down_menu" : "drop_down_menu close";
  };
  let inTextNumber = 0;
  const nedelje = [];
  return (
    <div className="calendar">
      {/* ---- Gornje ranfle kalendara ---- */}
      <div className="first">
        <h1>Crkveni pravoslavni kalendar</h1>
        <div
          className={`yearBox${setCloseClass()}`}
          onClick={() => {
            setDropDownYear(true);
          }}
          onMouseLeave={() => {
            setDropDownYear(false);
          }}
        >
          <b>{isYear}</b>
          <i class="fa-solid fa-square-caret-down"></i>
          <div className="botDiv">{items_list(calendarYears[0].item_list)}</div>
        </div>
      </div>
      <div className={`calendar-month${setCloseClass()}`}>
        <div>
          <SimpleButton clicked={() => changeMonth(-1)}>
            <i className="fa-solid fa-backward"></i>
            {tableTitle(-1)}
          </SimpleButton>
        </div>
        <div className="month-center"></div>
        <div>
          <SimpleButton clicked={() => changeMonth(1)}>
            {tableTitle(1)}
            <i className="fa-solid fa-forward"></i>
          </SimpleButton>
        </div>
      </div>
      {/* ---- END Gornje ranfle kalendara ---- */}

      {/* ---- Kalendar ---- */}
      <table className="calendar-table" cellspacing="0" cellpadding="0">
        <thead>
          <tr>
            {["Dani", "Novi", "Stari"].map((item, index) => {
              return (
                <th key={index}>
                  <span>{item}</span>
                </th>
              );
            })}
            <th>
              <h2>
                {tableTitle(0)} {isYear}
              </h2>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {setMonth(props.shortCal).map((item, index) => {
            let z = new Date(item.date);
            let zz = z.getDay();
            const tdClasses = ["onlyDay", "noDay", "before"];
            nedelje.push(inTextNumber);
            if (zz === 1) {
              inTextNumber++;
            }
            return (
              <React.Fragment>
                {zz === 1 && (
                  <tr className="opisNedelje">
                    <td colSpan={5}>
                      {[1, 2, 3, 4, 5].includes(inTextNumber) && (
                        <div className="banner-wrapper inCalendar">
                          <AdManagerSlot
                            adUnitPath={location.pathname}
                            slotNumber={inCalendarArr[inTextNumber - 1]}
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                )}
                <tr
                  key={index}
                  className={
                    rowClasses(item, zz) + todayClass(new Date(item.date))
                  }
                >
                  {tdClasses.map((x, index) => {
                    return (
                      <td key={index}>
                        <TimeFormat timePost={item.date} classes={x} />
                      </td>
                    );
                  })}
                  <td>
                    {/* <td> */}
                    <div className="test">
                      {renderTitleSection({
                        mainTitle: item.mainTitle !== undefined ? item.mainTitle : item.title,
                        slavaSymbol: item.slava,
                        extraLabel: item.extraLabel,
                        extraLabelLink: item.extraLabelLink,
                        separatorSymbol: item.separatorSymbol,
                        strongClass: item.strongClass,
                        mainClass: item.mainClass,
                      })}
                    </div>
                    {/* </td> */}
                  </td>
                  <td>{item.post}</td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
      {/* ---- END Kalendar ---- */}

      {/* ---- Donja ranfla kalendara ---- */}
      <div className="calendar-month" style={{ marginBottom: "30px" }}>
        {[-1, 0, 1].map((offset) => (
          <div key={offset} className={offset === 0 ? "month-center" : ""}>
            <SimpleButton clicked={() => changeMonth(offset)}>
              {offset === -1 && <i className="fa-solid fa-backward"></i>}
              {tableTitle(offset)}
              {offset === 1 && <i className="fa-solid fa-forward"></i>}
            </SimpleButton>
          </div>
        ))}
      </div>
      {/* ---- END Donja ranfla kalendara ---- */}
      <StickyAd
        adUnitPath={location.pathname}
        slotNumber={"div-gpt-ad-1745360544550-0"}
      />
    </div>
  );
}
